
/*
 * @Author: zhangyugegeliuchen@didichuxing.com
 * @Date: 2018-12-04 18:16:03
 * @Last Modified by: chenhui
 * @Last Modified time: 2021-10-08 16:16:16
 * @Description:  x推d落地页首页
 */
<template>
  <div>
    <div v-if="preview" class="page-title">{{ pageTitle }}</div>
    <rich-loading
      v-if="showLoading"
      :size="20"
      class="pageLoading"
    ></rich-loading>
    <div v-if="configInfo">
      <header class="pad-header" v-if="isIPad">
        <p>{{ gettext("推荐骑手") }}</p>
        <p @click="close">X</p>
      </header>
      <div :class="{ 'iPad-xtd-container': isIPad, 'xtd-container': !isIPad }">
        <div class="croppers">
          <div
            :class="{
              'xtd-container-main': !isIPad,
              'iPad-xtd-container-main': isIPad,
            }"
          >
            <div class="banner">
              <div
                class="img-wrapper"
                v-lazy:background-image="lazyImgObj(formatHeadImg)"
              ></div>
            </div>
          </div>
        </div>
        <div
          :class="{
            'xtd-container-footer': !isIPad,
            'iPad-xtd-container-footer': isIPad,
          }"
        >
          <div
            :class="{
              'iPad-xtd-container-detail': isIPad,
              'xtd-container-detail': !isIPad,
            }"
          >
            <common-income
              :preview="preview"
              :item="configInfo.activityCommon"
            />
            <div class="content">
              <div class="code-box">
                <div class="line-wrap" v-if="!isIPad">
                  <span class="text">{{ gettext("我的邀请码") }}</span>
                </div>
                <div class="copy-wrap">
                  <span class="code">{{
                    configInfo.activityCommon.showCode
                  }}</span>
                  <span
                    v-if="clipboard"
                    class="copy-btn"
                    :data-clipboard-text="copyText"
                    @click="copyHandle"
                  >
                  </span>
                </div>
                <div class="select-city" v-if="isIPad" @click="jumpSelectCity">
                  {{
                    configInfo.activityCommon.cityName
                      ? configInfo.activityCommon.cityName
                      : gettext("选择城市")
                  }}
                </div>
              </div>
              <div
                class="share-box"
                v-if="configInfo.activityCommon.validation === 1"
              >
                <share
                  :config="shareConfig"
                  v-if="meanfulXtdConfigInfo"
                  @trackShareClick="trackShareClick"
                />
              </div>
            </div>
            <!-- 邀请码 end -->
            <div class="content main-content">
              <div v-if="preview" class="preview-mask">
                <div v-for="i in 100" :key="`mask-${i}`">
                  <p>Demo</p>
                </div>
              </div>
              <h3>{{ $t("soda-m-i18n---奖励规则") }}</h3>
              <div class="select-city" v-if="!isIPad" @click="jumpSelectCity">
                {{
                  configInfo.activityCommon.cityName
                    ? configInfo.activityCommon.cityName
                    : gettext("选择城市")
                }}
              </div>
              <template v-if="configInfo.activityCommon.validation === 1">
                <div class="steps part">
                  <div v-if="ruleDetail.length">
                    <div
                      v-for="(item, index) in ruleDetail"
                      :key="index"
                      :class="index === 2 ? 'bdr' : ''"
                    >
                      <div :class="index === 2 ? 'stitle' : 'title'">
                        {{ item.title }}
                      </div>
                      <div
                        v-if="item.time_display && item.time_display.startTime"
                        :class="[0, 1].includes(index) ? 'scontent' : 'content'"
                      >
                        {{ formatTime(item.time_display.startTime) }} -
                        {{ formatTime(item.time_display.endTime) }}
                      </div>
                      <div
                        v-if="item.subText"
                        :class="[0, 1].includes(index) ? 'scontent' : 'content'"
                      >
                        {{ item.subText }}
                      </div>
                      <div
                        v-if="item.message"
                        :class="[0, 1].includes(index) ? 'scontent' : 'content'"
                      >
                        {{ item.message }}
                      </div>
                      <ul
                        v-if="item.steps && item.steps.length"
                        class="step-list"
                      >
                        <li
                          v-for="(t, i) in item.steps"
                          :key="i"
                          class="step-item line"
                        >
                          <div class="order-num">{{ i + 1 }}</div>
                          <div class="step-ct">
                            <div class="step-txt">
                              <h3>{{ t.subText }}</h3>
                              <div class="step-txt-content">
                                <template
                                  v-if="t.children && t.children.length === 1"
                                >
                                  <div
                                    v-for="(ct, ci) in t.children"
                                    :key="ci"
                                    class="step-txt-contents"
                                  >
                                    <p>{{ ct.subText }}</p>
                                  </div>
                                </template>
                                <template
                                  v-else-if="
                                    t.children && t.children.length > 1
                                  "
                                >
                                  <div
                                    v-for="(ct, ci) in t.children"
                                    :key="ci"
                                    class="step-txt-contents"
                                  >
                                    <strong>{{ ct.subText }}</strong>
                                    <p v-html="ct.message"></p>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <template v-if="item.children && item.children.length">
                        <div v-for="(st, si) in item.children" :key="si">
                          <div v-if="st.subText" class="content">
                            {{ st.subText
                            }}<span v-if="st.message"
                              ><a :href="st.message">{{ st.message }}</a></span
                            ><span v-if="st.hasOwnProperty('phone') && st.phone"
                              ><a class="phone" :href="'tel:' + st.phone">{{
                                st.phone
                              }}</a></span
                            >
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="noActivity">
                  <p>{{ gettext("该城市暂无活动") }}</p>
                </div>
              </template>
            </div>
            <!-- 规则规则 end -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  debounce,
  getShareConfig,
  getUrlLanguage,
  DEFAULT_IMG_BASE64,
  urlParse,
} from "@/common/js/utils";
import Schema from "@/common/js/schema";
import { globalParamsSchema } from "@/store/d/schema";
import trackEvent from "@/common/js/track";
import i18nUtil from "@didi/i18n-util";
import { getLocale } from "@didi/gettext";

import {
  getShopInfo,
  closePage,
  getUserInfo,
  getRiderBackBtn,
  setTitle,
} from "@/common/js/bridge";
// import { globalParamsSchema, xtdConfigSchema } from '@/store/d/schema'
// import noActivityImg from '@/assets/images/xtd/dgd_no_activity_banner_new.png'
import { getXtdPreviewData } from "./config/index";

import Clipboard from "clipboard";
import CommonIncome from "./commonIncome";
import SelectCity from "./selectCity";
import Share from "@/components/share/index";

export default {
  name: "landingPage",
  data() {
    return {
      preview: false,
      pageTitle: "",
      configInfo: {
        activityCommon: {},
        ruleDetail: {},
      },
      clipboard: null,
      shareConfig: {
        config: {},
        order: [],
      },
      sourceType: "d",
      sourceID: "",
      currentCityId: "",
      showLoading: true,
      noActivity: false,
    };
  },
  components: {
    CommonIncome,
    Share,
    SelectCity,
  },
  computed: {
    ...mapGetters(["globalParams", "xtdConfig"]),
    meanfulGlobalParams() {
      return Schema.compare(this.globalParams, globalParamsSchema);
    },
    meanfulXtdConfigInfo() {
      // return Schema.compare(this.xtdConfig, xtdConfigSchema)
      return true;
    },
    defaultBanner() {
      return require("../../../assets/images/xtd/dgd_no_activity_banner_new.png");
    },
    ruleDetail() {
      if (this.configInfo && this.configInfo.ruleDetail) {
        return Object.values(this.configInfo.ruleDetail);
      } else {
        return [];
      }
    },
    copyText() {
      if (
        this.configInfo &&
        this.configInfo.activityCommon.share &&
        this.configInfo.activityCommon.share.referralCode
      ) {
        return (
          this.configInfo &&
          this.configInfo.activityCommon.share &&
          this.configInfo.activityCommon.share.referralCode
        );
      } else {
        return (
          this.configInfo &&
          this.configInfo.activityCommon &&
          this.configInfo.activityCommon.showCode
        );
      }
    },
    formatHeadImg() {
      let headImgSchema = {
        list: [],
      };
      if (this.noActivity) {
        return this.defaultBanner;
      } else {
        return (
          this.meanfulXtdConfigInfo &&
          Schema.compare(
            this.configInfo.activityCommon.headImg,
            headImgSchema
          ) &&
          this.configInfo.activityCommon.headImg.list[0].url
        );
      }
    },
    country() {
      return this.$store.state.country;
    },
    officialUrl() {
      return this.country === "BR" ? "food.99app.com" : "www.didi-food.com";
    },
    path() {
      return this.country === "BR" ? "mobile-entregador" : "mobile-delivery";
    },
  },
  created() {
    const { preview } = this.$route.query;
    if (preview) {
      this.preview = true;
      window.addEventListener("message", (message) => {
        this.showLoading = false;
        if (message) {
          if (message.data.type === "normal") {
            const tmp = message.data.data || {};
            const { recommendPage = {} } = tmp || {};
            let config = getXtdPreviewData();
            config.activityCommon = {
              ...config.activityCommon,
              title: recommendPage && recommendPage.title,
              headImg: {
                list: [
                  {
                    imgUrl: [
                      {
                        ...((recommendPage && recommendPage.bannerImg) || {}),
                      },
                    ],
                    url:
                      (recommendPage &&
                        recommendPage.bannerImg &&
                        recommendPage.bannerImg.urlHttps) ||
                      "/img/dgd_no_activity_banner_new.325253c0.png",
                  },
                ],
                num: 1,
              },
            };

            this.pageTitle = recommendPage.title;
            this.configInfo = config;
            this.shareConfig.config = config.activityCommon.share;
            this.shareConfig.order = config.activityCommon.shareOrder;
          }
        }
      });
    } else {
      const QUERY_PARAMS = urlParse();
      const entrance = QUERY_PARAMS["entrance"] || "";
      if (this.isInDApp) getRiderBackBtn();
      this.initClipBoard();
      let riderId = ''
      this.getSourceInfo()
        .then((data) => {
          riderId = data.riderId
          return this.fetchAcquisitionConfig(data);
        })
        .then(() => {
          trackEvent({
            eventId: "sailing_d_x_recommend_sw",
            eventLabel: "X推D落地页展示",
            attrs: {
              rider_id: riderId,
              reward_id: this.configInfo.activityCommon.activityID,
              from_resource: this.isInDApp ? 1 : 0,
              version: this.configInfo.activityCommon.version,
              entrance: entrance, // 页面入口来源，如App_OpenAds(开屏banner)、Sidebar_Referral(侧边栏入口)等
            },
          });
        })
        .catch((err) => {
          const toast = this.$createToast({
            time: 3000,
            txt: "" + err,
            type: "error",
          });
          toast.show();
        });
    }
  },
  methods: {
    formatTime(prop) {
      return i18nUtil.getTimeFormat({
        timestamp: prop && prop.timestamp * 1000,
        offset: prop && prop.offset,
        locale: getLocale(),
        format: "YYYY.MM.DD",
      });
    },
    close() {
      closePage();
    },
    ...mapActions(["getGlobalInfo", "getXtdConfigInfo", "getShopInfos"]),
    initClipBoard() {
      // TODO: 不支持clipboard兼容
      if (Clipboard.isSupported()) {
        this.clipboard = new Clipboard(".copy-btn");
      }
    },
    async fetchAcquisitionConfig(data) {
      let res = await this.getXtdConfigInfo(data);

      if (res && res.errno === 0 && res.data) {
        this.configInfo = res.data;
        setTitle(
          this.configInfo.activityCommon.title || this.gettext("推荐骑手")
        );
        this.pageTitle =
          this.configInfo.activityCommon.title || this.gettext("推荐骑手");
        if (
          this.configInfo.activityCommon &&
          !this.configInfo.activityCommon.validation
        ) {
          this.noActivity = true;
        }
        this.currentCityId = res.data.activityCommon.cityID;
        // TODO: b端的页面还未配
        let shareUrl = "";
        if (this.isInDApp) {
          shareUrl = `${window.location.protocol}//${
            this.officialUrl
          }/${getUrlLanguage()}/${this.path}/register?share=1&activationCode=${
            this.configInfo.activityCommon.showCode
          }&country=${this.$store.state.country}`;
        }
        this.shareConfig.config = await getShareConfig(
          this.configInfo.activityCommon.share,
          shareUrl,
          this.configInfo.activityCommon.shareOrder
        );
        // 根据服务端下发展示顺序过滤用户侧主面板所展示的分享渠道
        this.shareConfig.order = this.configInfo.activityCommon.shareOrder;
        console.log(this.shareConfig);
        this.showLoading = false;
      } else {
        throw res && res.errmsg;
      }
    },
    jumpToRules() {
      trackEvent({
        eventId: "sailing_d_x_recommend_detail_ck",
        eventLabel: "X推D落地页-细则",
        attrs: {
          from_resource: this.isInDApp ? 1 : 0,
          version: this.configInfo.activityCommon.version,
        },
      });
      this.$router.push({
        path: `/d/detailRules?cityId=${this.currentCityId}&settlement=${this.configInfo.activityCommon.settlement}&unSettlement=${this.configInfo.activityCommon.unSettlement}`,
      });
    },
    jumpSelectCity() {
      this.$Floating({
        type: "confirm",
        height: "90%",
        btnOkText: this.$t("soda-m-i18n---完成" /* 完成 */),
        btnCancelText: this.$t("soda-m-i18n---取消" /* 取消 */),
        onOk: () => {
          this.showLoading = true;
          this.getSourceInfo().then((data) => {
            return this.fetchAcquisitionConfig({
              ...data,
              cityId: this.currentCityId,
              sourceType: "d",
              sourceID: "d",
              required: true,
            });
          });
          return true;
        },
        content: (
          <select-city
            cityList={this.configInfo.activityCommon.cityList}
            locationCity={this.configInfo.activityCommon.cityName}
            on-selected={this.handleSelected}
          />
        ),
      });
    },
    handleSelected(city) {
      this.currentCityId = city.cityId;
    },
    copyHandle: debounce(function () {
      if (this.preview) return;
      trackEvent({
        eventId: "sailing_d_x_recommend_copy_ck",
        eventLabel: "X推D落地页-邀请码复制点击",
        attrs: {
          from_resource: this.isInDApp ? 1 : 0,
          copy_text: this.copyText || "",
          version: this.configInfo.activityCommon.version || 1,
          awarded_bouns: this.configInfo.activityCommon.settlement || 0,
          total_bouns: this.configInfo.activityCommon.unSettlement || 0,
        },
      });
      this.clipboard.on("success", (e) => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext("复制成功"),
          type: "correct",
        });
        toast.show();
        e.clearSelection();
      });
      this.clipboard.on("error", (e) => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext("当前手机系统不支持自动复制"),
          type: "error",
        });
        toast.show();
        e.clearSelection();
      });
    }, 200),
    lazyImgObj(value) {
      return {
        src: value,
        error: DEFAULT_IMG_BASE64,
        loading: DEFAULT_IMG_BASE64,
      };
    },
    getSourceInfo() {
      if (this.isInDApp) {
        return Promise.all([this.getGlobalInfo(), getUserInfo()])
          .then((data) => {
            this.sourceType = "d";
            this.sourceID = data[1].uid;
            return {
              ...data[0],
              ...data[1],
              sourceType: "d",
              sourceID: data[1].uid,
            };
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else if (this.isInBApp || this.isIPad) {
        return Promise.all([this.getGlobalInfo(), getShopInfo()]).then(
          (data) => {
            this.sourceType = "b";
            this.sourceID = data[1].shopId;
            return {
              ...data[0],
              ...data[1],
              sourceType: "b",
              sourceID: data[1].shopId,
            };
          }
        );
      }
      return Promise.resolve({});
    },
    trackShareClick(plantform) {
      if (this.preview) return;
      trackEvent({
        eventId: "sailing_d_x_recommend_share_ck",
        eventLabel: "X推D落地页-分享",
        attrs: {
          from_resource: this.isInDApp ? 1 : 0,
          to_resource: plantform,
          version: this.configInfo.activityCommon.version || 1,
          awarded_bouns: this.configInfo.activityCommon.settlement || 0,
          total_bouns: this.configInfo.activityCommon.unSettlement || 0,
        },
      });
    },
  },

  beforeDestroy() {
    this.clipboard && this.clipboard.destroy();
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/common/stylus/variables';

$conversion = 0.5859375px;

.pageLoading {
  position: absolute;
  top: 50%;
  width: 100%;
}

.page-title {
  font-size: 16px;
  text-align: center;
  padding: 5px 0;
  background:#fff;
}

.xtd-container {
  background: #f5f5f7;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 0;

  &-main {
    margin: 0 auto 32px;

    .banner {
      width: 100%;
      height: 375px;

      .img-wrapper {
        width: auto;
        height: 375px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
    }
  }

  .cropper {
    position: fixed;
    top: 0;
    bottom: 244px;
    overflow-y: auto;
  }

  .xtd-common-income-container {
    margin: 0 32px 24px;
    border-radius: 24px;
  }

  .xtd-container-main {
    margin-bottom: 32px;
  }

  .noActivity {
    margin: 120px auto;

    p {
      font-family: 'Aspira Regular';
      font-size: 32px;
      color: #999;
      text-align: center;
      font-weight: 400;
    }
  }

  .content {
    margin: 0 32px 24px;
    border-radius: 24px;
    background: #fff;
    padding: 56px 40px;
    text-align: left;

    h3 {
      font-family: 'Aspira Demi';
      font-style: normal;
      text-align: left;
      font-size: 40px;
      color: #000;
      font-weight: 500;
    }

    a {
      word-break: break-word;
    }

    .steps {
      .bdr {
        margin-bottom: 52px;
        padding-top: 56px;
        padding-bottom: 24px;
        border-top: 1px #e5e5e5 solid;
        border-bottom: 1px #e5e5e5 solid;
      }

      .title {
        margin-bottom: 16px;
        font-family: 'Aspira Regular';
        font-size: 24px;
        color: #999;
        line-height: 40px;
        font-weight: 400;
      }

      .stitle {
        margin-bottom: 16px;
        font-family: 'Aspira Demi';
        font-size: 40px;
        color: #000;
        line-height: 40px;
        font-weight: 600;
      }

      .content {
        margin: 0 0 52px;
        padding: 0;
        opacity: 0.8;
        font-family: 'Aspira Regular';
        font-size: 28px;
        color: #404040;
        font-weight: 400;
        letter-spacing: 0;

        a {
          color: #FF7A45;
        }

        .phone {
          margin-left: 6px;
        }
      }

      .scontent {
        margin: 0 0 52px;
        padding: 0;
        opacity: 0.8;
        font-family: 'Aspira Regular';
        font-size: 32px;
        color: #000;
        font-weight: 400;
        letter-spacing: 0;

        a {
          color: #FF7A45;
        }

        .phone {
          margin-left: 6px;
        }
      }

      .step-list {
        margin-top: 56px;

        .step-item {
          display: flex;

          &.line {
            position: relative;

            &::after {
              position: absolute;
              content: '';
              width: 0;
              display: block;
              height: 100%;
              left: 16px;
              border: 2px dashed #000;
            }
          }

          &:last-child {
            &.line:after {
              display: none;
            }
          }

          .order-num {
            position: relative;
            z-index: 1;
            width: 32px;
            height: 32px;
            font-family: 'PingFang-SC-Semibold';
            font-size: 24px;
            text-align: center;
            font-weight: 600;
            border-radius: 50%;
            background: #000;
            color: #fff;
            line-height: 32px;
            text-align: center;
            flex-shrink: 0;
          }

          .step-ct {
            width: 100%;
            margin-left: 32px;

            .step-txt {
              background: #F5F5F5;
              border-radius: 8px;
              padding: 24px;
              margin: -5px auto 32px;

              h3 {
                margin-bottom: 12px;
                font-family: 'Aspira Demi';
                font-size: 32px;
                color: #000;
                line-height: 40px;
                font-weight: 600;
              }

              .step-txt-content {
                strong {
                  margin-top: 28px;
                  display: block;
                  margin-bottom: 9px;
                  font-family: 'Aspira Medium';
                  font-size: 24px;
                  color: #000;
                  line-height: 30px;
                  font-weight: 500;
                }

                strong:first-child {
                  // margin-top: 0
                }

                p {
                  font-family: 'Aspira Regular';
                  font-size: 24px;
                  color: #666;
                  line-height: 30px;
                  font-weight: 400;
                }
              }
            }
          }
        }
      }
    }
  }

  .content:last-child {
    // margin-bottom: 0
  }

  .main-content {
    position: relative;
    overflow: hidden;

    .preview-mask {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      z-index: 2;

      div {
        margin: 35px;
        transform: rotate(30deg);
        font-size: 36px;
        font-weight: 600;
        opacity: 0.1;

        p {
          margin-bottom: 0;
        }
      }
    }
  }

  &-footer {
    .xtd-container-detail {
      margin-bottom: 0;
      padding-bottom: 5px;
      text-align: center;
    }

    .detail-rules {
      color: #999;
      font-size: 32px;
      text-align: center;

      .richic-arrow {
        color: #999999;
        font-size: 24px;
        margin-right: -32px;
      }
    }

    // .rich-input:after {
    // border: none;
    // }
    .line-wrap {
      display: flex;
      justify-content: left;

      .line {
        display: block;
        width: 146px;
        height: 2px;
        margin-top: 14px;

        &.r {
          background: linear-gradient(to right, #D8D8D8, #ffffff);
          margin-left: 24px;
        }

        &.l {
          background: linear-gradient(to right, #ffffff, #D8D8D8);
          margin-right: 24px;
        }
      }

      .text {
        font-family: 'Aspira Demi';
        color: #000;
        display: block;
        font-size: 40px;
        margin-bottom: 48px;
        text-align: left;
        font-weight: 600;
      }
    }

    .select-city {
      position: relative;
      margin: 32px auto 42px;
      padding: 0 56px 0 24px;
      box-sizing: border-box;
      height: 56px;
      line-height: 56px;
      border-color(2px);
      text-align: center;
      display: inline-block;
      border-radius: 100px;
      font-family: 'Aspira Medium';
      font-size: 24px;
      font-color();

      &::after {
        position: absolute;
        display: block;
        content: '';
        width: 11px;
        height: 20px;
        arrow-right();
        right: 24px;
        top: 50%;
        margin-top: -10px;
      }
    }

    .code-box {
      text-align: center;

      .copy-wrap {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0;

        .copy-btn {
          display: inline-block;
          width: 40px;
          height: 40px;
          copy-icon();
          margin-left: 15px;
          box-sizing: border-box;
        }

        .code {
          font-family: 'Aspira Demi';
          font-size: 48px;
          color: #000;
          text-align: left;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 48px;
          -webkit-user-select: text;
        }
      }
    }

    .share-box {
      border-top: 1px #ebebeb solid;
      margin-top: 24px;

      .title {
        font-size: 28px;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
        margin-bottom: 19px;
      }

      .share-wrap >>> .icons {
        padding: 0 0 7px;
        justify-content: space-between;

        .icon {
          padding-top: 35px;
          margin-left: 0;

          img {
            width: 90px;
            height: 90px;
          }
        }
      }
    }
  }
}

.iPad-xtd-container {
  background: white;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 28 * $conversion 60 * $conversion 60 * $conversion 60 * $conversion;
  display: flex;

  &-main {
    margin-right: 60 * $conversion;

    .banner {
      .img-wrapper {
        width: 590 * $conversion;
        height: 599 * $conversion;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
    }
  }

  &-footer {
    position: relative;
    flex: 1;

    .iPad-xtd-common-income-container {
      position: absolute;
      bottom: 0;
    }

    .iPad-xtd-container-detail {
      padding-top: 64 * $conversion;
    }

    .detail-rules {
      color: #4A4A4A;
      font-size: 18 * $conversion;
      margin-top: 28 * $conversion;
      text-align: center;

      .richic-arrow {
        color: #999999;
        font-size: 11 * $conversion;
        margin-left: 8 * $conversion;
      }
    }

    // .rich-input:after {
    // border: none;
    // }
    .line-wrap {
      display: flex;
      justify-content: center;

      .line {
        display: block;
        width: 100 * $conversion;
        height: 2 * $conversion;
        margin-top: 9 * $conversion;

        &.r {
          background: linear-gradient(to right, #D8D8D8, #ffffff);
          margin-left: 14 * $conversion;
        }

        &.l {
          background: linear-gradient(to right, #ffffff, #D8D8D8);
          margin-right: 14 * $conversion;
        }
      }

      .text {
        color: #999999;
        display: block;
        font-size: 20 * $conversion;
        text-align: center;
      }
    }

    .code-box {
      margin-top: 18 * $conversion;
      text-align: center;

      .copy-wrap {
        display: flex;
        justify-content: center;
        align-items: center;

        .copy-btn {
          display: inline-block;
          width: 40 * $conversion;
          height: 40 * $conversion;
          copy-icon($conversion);
          margin-left: 16 * $conversion;
          box-sizing: border-box;
        }

        .code {
          font-size: 48 * $conversion;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          line-height: 48 * $conversion;
          font-weight: bold;
          -webkit-user-select: text;
        }
      }
    }

    .select-city {
      position: relative;
      margin: 40 * $conversion auto 50 * $conversion;
      padding: 0 34 * $conversion 0 16 * $conversion;
      min-width: 100 * $conversion;
      text-align: left;
      box-sizing: border-box;
      display: inline-block;
      line-height: 42 * $conversion;
      height: 42 * $conversion;
      border-color(1 * $conversion);
      border-radius: 100 * $conversion;
      font-family: Aspira Medium;
      font-size: 18 * $conversion;
      font-color();

      &::after {
        position: absolute;
        display: block;
        content: '';
        width: 6 * $conversion;
        height: 10 * $conversion;
        arrow-right();
        right: 20 * $conversion;
        top: 50%;
        margin-top: -5 * $conversion;
      }
    }

    .share-box {
      margin-top: 78 * $conversion;

      .title {
        font-size: 20 * $conversion;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
        margin-bottom: 24 * $conversion;
      }

      .share-wrap {
        color: #ff0000;

        .share {
          .icons {
            padding: 0 0 15px;
            justify-content: space-between;

            .icon {
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
